<template>
  <Minimal v-if="isMinimal" :is-checkout="isCheckout" />
  <Responsive v-else />
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { defineAsyncComponent } from 'vue';

import Responsive from './footer/Responsive.mcom';

defineProps({
  isMinimal: {
    type: Boolean,
    default: false,
  },
  isCheckout: {
    type: Boolean,
    default: false,
  },
});

const Minimal = defineAsyncComponent(() => import(/* webpackChunkName: "Minimal" */ './footer/MinimalFooter.common'));
</script>
